/**
 * This function will debounce calls to functions.
 *
 * @param callback - callback to call.
 * @param time - time time to wait between calls in ms.
 * @returns a function that will call the callback after the time has passed.
 */
export function Debounce(callback, time) {
    let timerId;
    return function (...args) {
        clearTimeout(timerId);
        timerId = setTimeout(() => callback(...args), time);
    };
}
//# sourceMappingURL=debounce.js.map